/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { SpaceId } from "../../../commons/types/SpaceId";
export const UpdateCanvasRequest = core.serialization.object({
    namespace: core.serialization.string().optional(),
    context: core.serialization.any().optional(),
    metadata: core.serialization.any().optional(),
    layout: core.serialization.any().optional(),
    spaceId: SpaceId.optional(),
});
